import { useContext } from 'react';
import { EmbedsContext } from '../components/context/embeds-context';
import { isEmpty } from 'lodash';
import { useEntity } from './use-entity';
export var useEmbeds = function useEmbeds() {
  var embedsContext = useContext(EmbedsContext);
  var entity = useEntity(); // console.log("EMBEDS ENTTIY", entity);

  if (isEmpty(embedsContext)) {
    return entity.embeds || {};
  }

  return embedsContext;
};